import { render, staticRenderFns } from "./ProductProposalCard.vue?vue&type=template&id=10ca188c"
import script from "./ProductProposalCard.vue?vue&type=script&lang=js"
export * from "./ProductProposalCard.vue?vue&type=script&lang=js"
import style0 from "./ProductProposalCard.vue?vue&type=style&index=0&id=10ca188c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports